import { Component,OnInit } from '@angular/core';
import { LoaderService } from '../../../app/services/loader.service';

@Component({
    selector: 'learner',
    templateUrl: './learner.template.html',
    styleUrls: ['./learner.style.scss'],
    standalone: false
})

export class Learner implements OnInit {

  constructor(
    private loaderService: LoaderService){}
  
  ngOnInit() {
    document.body.classList.add("module-learner");
    this.loaderService.hideLoader();
  }

}